export default __webpack_public_path__ + "static/media/posicionando.223ef6ad.png";